/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyResource } from '../models/CompanyResource';
import type { CustomerRequest } from '../models/CustomerRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CustomerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Detail d'une entreprise
     * Avec son serveur et l'adresse du serveur Lol@pp declaree dans Lola (`lolap_server`).
     * @param customerId
     * @returns CompanyResource `CompanyResource`
     * @throws ApiError
     */
    public adminCustomerShow0(
        customerId: string,
    ): CancelablePromise<CompanyResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/company/{customer_id}',
            path: {
                'customer_id': customerId,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Lister les entreprises
     * Toutes les entreprises actives ou non, avec leur serveur et leurs images (fond, logo, en-tete, icone).
     * @returns CompanyResource Array of `CompanyResource`
     * @throws ApiError
     */
    public adminCompanyIndex(): CancelablePromise<Array<CompanyResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/company',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Creer une entreprise
     * @param requestBody
     * @returns CompanyResource `CompanyResource`
     * @throws ApiError
     */
    public adminCompanyStore(
        requestBody?: CustomerRequest,
    ): CancelablePromise<CompanyResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/company',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'une entreprise
     * Avec son serveur et l'adresse du serveur Lol@pp declaree dans Lola (`lolap_server`).
     * @param customerId
     * @returns CompanyResource `CompanyResource`
     * @throws ApiError
     */
    public adminCompanyShow(
        customerId: string,
    ): CancelablePromise<CompanyResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/company/{customer_id}',
            path: {
                'customer_id': customerId,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Modifier une entreprise
     * Mise a jour partielle. **Desactiver une entreprise (`active: false`) deconnecte immediatement tous ses personnels.** 404 si elle n'existe pas.
     * @param customerId
     * @param requestBody
     * @returns CompanyResource `CompanyResource`
     * @throws ApiError
     */
    public adminCompanyUpdate(
        customerId: string,
        requestBody?: CustomerRequest,
    ): CancelablePromise<CompanyResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/admin/company/{customer_id}',
            path: {
                'customer_id': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer une entreprise
     * Supprime la fiche de l'entreprise (pas ses donnees Lola ni ses fichiers). Reponse : `{ message }`.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public adminCompanyDestroy(
        id: string,
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/company/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Executer une requete SQL sur la base Lola d'une entreprise
     * Outil d'administration : execute `code` (SQL) sur la base Lola de l'entreprise designee par `Company-Key`. Reponse : le resultat dans `message`.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public customerExecuteSql(
        requestBody: {
            code: string;
        },
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/execute',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
}
